/* Routes for sidebar menu
  For a single entry: {
    name: Entry Display Name,
    icon: Entry Icon,
    ID: dashboardRoutes.[route name].ID,
    path: dashboardRoutes.[route name].path,
  }

  For a folder: {
    name: Folder Display Name,
    icon: Folder Icon,
    ID: random ID for key for component in the loop,
    children: [{
      name: Sub entry name,
      path: dashboardRoutes.[route name].path,
    }],
  }
*/

import { MdCampaign } from "react-icons/md";
import { HiTemplate } from "react-icons/hi";
import { IoSettings } from "react-icons/io5";
import { FaUserGroup } from "react-icons/fa6";
import { HiUserGroup } from "react-icons/hi2";
import { BiRadioCircle } from "react-icons/bi";
import { FaHandshakeSimple } from "react-icons/fa6";
import { BiSolidUserAccount } from "react-icons/bi";
import { RiChatSettingsFill } from "react-icons/ri";
import { MdOutlineBrandingWatermark } from "react-icons/md";

import dashboardLayoutRoutes from "../../../router/router components/dashboardLayoutRoutes";
const routes = [
  {
    name: "Profile",
    icon: FaUserGroup,
    ID: dashboardLayoutRoutes.brandDetailsRoute.ID,
    children: [
      {
        ID: dashboardLayoutRoutes.agencyDetailsRoute.ID,
        name: "Agency",
        path: dashboardLayoutRoutes.agencyDetailsRoute.path,
      },
      {
        ID: dashboardLayoutRoutes.brandDetailsRoute.ID,
        name: "Brand",
        path: dashboardLayoutRoutes.brandDetailsRoute.path,
      },
      {
        ID: dashboardLayoutRoutes.companyDetailsRoute.ID,
        name: "Company",
        path:
          dashboardLayoutRoutes.companyDetailsRoute.path +
          "?withCompany=" +
          true,
      },
      {
        ID: dashboardLayoutRoutes.companyDetailsRoute.ID,
        name: "User Profile",
        path: dashboardLayoutRoutes.profileDetailsRoute.path,
      },
    ],
  },

  {
    name: "Audience",
    icon: HiUserGroup,
    ID: dashboardLayoutRoutes.audienceListRoute.ID,
    children: [
      {
        ID: dashboardLayoutRoutes.createAudienceRoute.ID,
        name: "Create Audience",
        path: dashboardLayoutRoutes.createAudienceRoute.path,
      },
      {
        name: "Audience List",
        ID: dashboardLayoutRoutes.audienceListRoute.ID,
        path: dashboardLayoutRoutes.audienceListRoute.path,
      },
    ],
  },

  {
    name: "Templates",
    icon: HiTemplate,
    ID: dashboardLayoutRoutes.templateListRoute.ID,
    children: [
      {
        name: "Whatsapp Templates",
        ID: dashboardLayoutRoutes.templateListRoute.ID,
        icon: BiRadioCircle,
        subChilds: [
          {
            ID: dashboardLayoutRoutes.templateListRoute.ID,
            name: "Templates List",
            path: dashboardLayoutRoutes.templateListRoute.path,
          },
          // {
          //   ID: dashboardLayoutRoutes.templateCreateRoute.ID,
          //   name: "Create Template",
          //   path: dashboardLayoutRoutes.templateCreateRoute.path,
          // },
        ],
      },
    ],
  },

  {
    name: "Campaigns",
    icon: MdCampaign,
    ID: dashboardLayoutRoutes.myCampaignRoute.ID,
    children: [
      {
        name: "Create Campaign",
        ID: dashboardLayoutRoutes.createCampaignRoute.ID,
        path: dashboardLayoutRoutes.createCampaignRoute.path,
      },
      {
        name: "Campaign List",
        ID: dashboardLayoutRoutes.myCampaignRoute.ID,
        path: dashboardLayoutRoutes.myCampaignRoute.path,
      },
    ],
  },

  {
    name: "Accounts",
    icon: BiSolidUserAccount,
    ID: dashboardLayoutRoutes.accountVerificationRoute.ID,
    path: dashboardLayoutRoutes.accountVerificationRoute.path,
  },

  {
    name: "Verification",
    icon: MdOutlineBrandingWatermark,
    ID: dashboardLayoutRoutes.unverifiedRoute.ID,
    children: [
      {
        name: "Brands",
        ID: dashboardLayoutRoutes.unverifiedRoute.ID,
        path: dashboardLayoutRoutes.unverifiedRoute.path,
      },
    ],
  },

  {
    name: "Campaigns",
    icon: MdCampaign,
    ID: dashboardLayoutRoutes.superadminAllCampaignsRoute.ID,
    path: dashboardLayoutRoutes.superadminAllCampaignsRoute.path,
  },

  {
    name: "Campaigns",
    icon: MdCampaign,
    ID: dashboardLayoutRoutes.campaignRequestRoute.ID,
    path: dashboardLayoutRoutes.campaignRequestRoute.path,
  },

  {
    name: "Users",
    icon: FaUserGroup,
    ID: dashboardLayoutRoutes.brandListRoute.ID,
    path: dashboardLayoutRoutes.brandListRoute.path,
  },

  {
    name: "On-Boarding",
    icon: FaHandshakeSimple,
    ID: dashboardLayoutRoutes.superadminDPOnBoardingListRoute.ID,
    path: dashboardLayoutRoutes.superadminDPOnBoardingListRoute.path,
  },

  {
    name: "Channel Settings",
    icon: RiChatSettingsFill,
    ID: dashboardLayoutRoutes.channelAgentSettingRoute.ID,
    path: dashboardLayoutRoutes.channelAgentSettingRoute.path,
  },

  // {
  //   name: "WhatsApp Onboarding",
  //   icon: IoLogoWhatsapp,
  //   ID: dashboardLayoutRoutes.whatsAppOnboardingPageRoute.ID,
  //   path: dashboardLayoutRoutes.whatsAppOnboardingPageRoute.path,
  // },

  {
    name: "Settings",
    icon: IoSettings,
    ID: dashboardLayoutRoutes.superadminPermissionSettingsRoute.ID,
    children: [
      {
        ID: dashboardLayoutRoutes.superadminPermissionSettingsRoute.ID,
        name: "Permission Settings",
        path: dashboardLayoutRoutes.superadminPermissionSettingsRoute.path,
      },
      {
        ID: dashboardLayoutRoutes.superadminDynamicUISetting.ID,
        name: "Site Settings",
        path: dashboardLayoutRoutes.superadminDynamicUISetting.path,
      },
    ],
  },
];

export default routes;
